import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { useLocation } from 'react-router-dom';

const links = [
    { to: '/', label: 'Home' },
    { to: '/layanan', label: 'Layanan' },
    { to: '/portofolio', label: 'Portofolio' },
    { to: '/karir', label: 'Karir' },
    { to: '/kontak', label: 'Kontak' },
];

const NavLinks = () => {
    const location = useLocation();

    return (
        <>
            {links.map(({ to, label }) => {
                const active = location.pathname === to;
                return (
                    <HashLink
                        key={to}
                        smooth
                        to={to}
                        className={`relative px-4 py-2.5 text-sm font-medium text-[#BD1E26] lg:text-white
                            transition-colors duration-200 hover:text-brand-light lg:hover:text-white/80
                            after:content-[''] after:absolute after:left-4 after:right-4 after:-bottom-0.5
                            after:h-0.5 after:rounded-full after:bg-current after:transition-transform after:duration-300 after:origin-left
                            ${active ? 'after:scale-x-100' : 'after:scale-x-0 hover:after:scale-x-100'}`}
                    >
                        {label}
                    </HashLink>
                );
            })}
        </>
    );
};

export default NavLinks;
